<template>
  <div class="mt-15 container-inner">
    <h3 class="title-type-2">
      <strong>{{ inventory.name }}</strong> 상품 세부 설정
    </h3>
    <div class="mb-8">
      <h4 class="title-type-3">
        지면설명
        <span class="attention-coment-1 ml-2">
          <v-icon>mdi-alert-circle</v-icon>
          이미지 배너 광고 필요시 설정
        </span>
      </h4>
    </div>

    <!-- 이미지 업로드 -->
    <div class="mb-8" v-if="isShowImage && !isShowVideo" key="image">
      <h4 class="mt-8 title-type-3">
        이미지 업로드
        <span class="required">
          <v-icon>mdi-check-circle-outline</v-icon>
          필수
        </span>
      </h4>

      <div class="resource-wrap">
        <ResourceImage1
          :propsInventoryType="inventory.type"
          :propsInventoryId="propsInventoryId"
          :propsInventory="inventory"
          :propsLineItemId="lineItemId"
          :propsLriId="lriId"
          :propsResources="resources"
          :propsAdvertiserId="propsAdvertiserId"
          @getResourceAfterAdd="updateDetailLineitemForResource"
          @getResourceAfterDelete="deleteDetailLineitemForResource"
        />
      </div>
    </div>
    <!-- //이미지 업로드 -->

    <!-- 영상 업로드 -->
    <div class="mb-8" v-if="!isShowImage && isShowVideo" key="video">
      <h4 class="mt-8 title-type-3">
        영상 업로드
        <span class="required">
          <v-icon>mdi-check-circle-outline</v-icon>
          필수
        </span>
      </h4>
      <div class="resource-wrap">
        <ResourceVideo1
          :propsInventoryType="inventory.type"
          :propsInventoryId="propsInventoryId"
          :propsInventory="inventory"
          :propsLineItemId="lineItemId"
          :propsLriId="lriId"
          :propsResources="resources"
          :propsAdvertiserId="propsAdvertiserId"
          @getResourceAfterAdd="updateDetailLineitemForResource"
          @getResourceAfterDelete="deleteDetailLineitemForResource"
        />
      </div>
    </div>
    <!-- //영상 업로드 -->
    <!-- 이미지 동영상 라디오 체크 -->
    <div class="mb-8" v-if="isShowImage && isShowVideo" key="imageAndVideo">
      <h4 class="mt-8 title-type-3">
        이미지 & 동영상 업로드
        <span class="required">
          <v-icon>mdi-check-circle-outline</v-icon>
          필수
        </span>
      </h4>
      <div class="resource-wrap rounded white" style="border: 1px solid black">
        <div class="form-row-1 pa-6">
          <p class="label pt-0">소재타입</p>
          <div class="write-con">
            <v-radio-group
              v-model="resourceType"
              class="mt-0"
              row
              hide-details
              @change="typeChange($event)"
            >
              <v-radio
                label="동영상"
                value="video"
                color="#fecd00"
                class="radio-type-1"
              ></v-radio>
              <v-radio
                label="이미지"
                value="img"
                color="#fecd00"
                class="radio-type-1 ml-10"
              ></v-radio>
            </v-radio-group>
          </div>
        </div>
        <!-- 이미지, 동영상 소재타입 -->
        <div>
          <div v-if="this.resourceType === 'video'">
            <ResourceVideo1
              :propsInventoryType="inventory.type"
              :propsInventoryId="propsInventoryId"
              :propsInventory="inventory"
              :propsLineItemId="lineItemId"
              :propsLriId="lriId"
              :propsResources="resources"
              :propsAdvertiserId="propsAdvertiserId"
              :propsResourceType="`both`"
              @getResourceAfterAdd="updateDetailLineitemForResource"
              @getResourceAfterDelete="deleteDetailLineitemForResource"
            />
          </div>
          <div v-else>
            <ResourceImage1
              :propsInventoryType="inventory.type"
              :propsInventoryId="propsInventoryId"
              :propsInventory="inventory"
              :propsLineItemId="lineItemId"
              :propsLriId="lriId"
              :propsResources="resources"
              :propsAdvertiserId="propsAdvertiserId"
              :propsResourceType="`both`"
              @getResourceAfterAdd="updateDetailLineitemForResource"
              @getResourceAfterDelete="deleteDetailLineitemForResource"
            />
          </div>
        </div>
      </div>
      <!-- 이미지, 동영상 소재타입 -->
    </div>
    <!-- //이미지 동영상 라디오 체크 -->

    <!-- 클릭 URL -->
    <div>
      <h4 class="title-type-3">클릭 URL</h4>
      <div class="relative white rounded pa-6 mb-8 pr-12">
        <div class="form-row-1">
          <p class="label">클릭 URL</p>
          <div class="write-con d-flex">
            <v-select
              :items="linkType"
              label="선택"
              v-model="linkSelectChoice"
              item-color="#000"
              class="input-custom-2"
              height="40px"
              style="max-width: 16%"
              solo
              hide-details
            ></v-select>
            <v-text-field
              v-model="linkUrl"
              placeholder="URL 입력 해주세요"
              class="input-custom-2 ml-2"
              height="40px"
              style="flex: 1"
              solo
            ></v-text-field>
            <v-btn
              large
              depressed
              max-height="40px"
              color="#fecd06"
              class="button-type-1 ml-2"
              @click.stop="onClickRedirect"
              :disabled="!linkUrl || linkSelectChoice === '내부(앱내)'"
            >
              미리보기
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <!-- //클릭 URL -->
    <div class="d-flex justify-end mt-10">
      <v-btn
        large
        depressed
        max-height="40px"
        color="#fff"
        class="button-type-1"
        @click.stop="cancel"
      >
        취소
      </v-btn>
      <v-btn
        large
        depressed
        max-height="40px"
        color="#fecd06"
        class="button-type-1 ml-4"
        @click.prevent="saveLineItem"
      >
        저장
      </v-btn>
    </div>
    <SystemAlert v-model="showSystemAlert">
      <div slot="noti-text" v-html="logResult"></div>
      <div slot="noti-btns">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="showSystemAlert = false"
        >
          확인
        </v-btn>
      </div>
    </SystemAlert>
  </div>
</template>

<script>
import bus from '@/utils/bus';
import SystemAlert from '~@/modal/SystemAlert.vue';
import { toISOFormattedDate } from '@/utils/validation';
import { optionsList } from '@/api/options';

import {
  getDetailCampaignLineItem,
  updateDetailCampaignLineItem,
  addOptionItem,
  updateOptionItem,
} from '@/api/campaign';

import ResourceImage1 from './resourceImage1.vue';
import ResourceVideo1 from './resourceVideo1.vue';

export default {
  components: {
    SystemAlert,
    ResourceImage1,
    ResourceVideo1,
  },
  props: {
    propsInventory: Object,
    propsInventoryId: String,
    propsLineItem: Object,
    propsDateRange: Object,
    propsAdvertiserId: String,
  },
  data: () => ({
    isShowImage: false,
    isShowVideo: false,
    resourceType: 'video',

    showSystemAlert: false,
    logResult: '',

    linkType: ['외부(새창)', '내부(앱내)'], //external, internal
    linkSelectChoice: '',
    linkUrl: '',

    isValid: 'Y',

    options: [],
    optionItemsMap: {},

    lineItem: {},
    lineItemId: '',
    lris: [],
    lri: {},
    lriId: '',
    lrisMap: {},

    resources: [],
    defaultResource: {
      dateRange: { startDate: null, endDate: null },
      id: '',
      name: '',
      start_at: null,
      end_at: null,
      is_valid: '',
      type: 1,
      hash: '',
      file: '',
    },
    resourceId: '',
    imageItemId: '',
    videoItemId: '',
  }),
  computed: {
    inventory: {
      get() {
        return this.propsInventory;
      },
      set(value) {
        this.propsInventory = value;
      },
    },
    defaultStartAt() {
      return this.propsInventory.start_at;
    },
    defaultEndAt() {
      return this.propsInventory.end_at;
    },
  },
  methods: {
    async getOptions() {
      try {
        const { data } = await optionsList();
        this.options = data.list;
        (this.options || []).forEach(option => {
          /**
           * 기존 옵션 이름으로 체크하던 조건 변경
           * option.name === '이미지 광고'
           */
          if (option.key === 'image') {
            option.items.forEach(item => {
              this.imageItemId = item.id;
            });
          }
          /**
           * 기존 옵션 이름으로 체크하던 조건 변경
           * option.name === '동영상 광고'
           */
          if (option.key === 'video') {
            option.items.forEach(item => {
              this.videoItemId = item.id;
            });
          }
        });
      } catch (error) {
        console.log(error.response);
      }
    },
    async getDetailLineItem(emitData) {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const LineItemId = this.propsLineItem.id;
      try {
        const { data } = await getDetailCampaignLineItem(
          campaignId,
          inventoryId,
          LineItemId,
        );

        //옵션에 따라서 이미지광고, 동영상광고 보이게 끔한다.
        const options = data.row.medias[0].inventories[0].options;
        options.forEach(option => {
          /**
           * 기존 옵션 이름으로 체크하던 조건 변경
           * option.name === '이미지 광고'
           */
          if (option.key === 'image') {
            this.isShowImage = true;
          }
          /**
           * 기존 옵션 이름으로 체크하던 조건 변경
           * option.name === '동영상 광고'
           */
          if (option.key === 'video') {
            this.isShowVideo = true;
          }
        });

        this.lineItem = data.row.medias[0].inventories[0].lineitems[0];
        this.lineItemId = data.row.medias[0].inventories[0].lineitems[0].id;

        //노출 세팅
        this.isValid = this.lineItem.is_valid;

        //클릭  url 세팅
        if (this.lineItem.link_type === 'external') {
          this.linkSelectChoice = '외부(새창)';
        } else {
          //internal
          this.linkSelectChoice = '내부(앱내)';
        }
        this.linkUrl = this.lineItem.link_url;

        if (this.lineItem.lris.length > 0) {
          this.lris = this.lineItem.lris;
          this.lri = this.lineItem.lris[0];
          this.lriId = this.lineItem.lris[0].id;

          this.resources = this.lineItem.lris[0].resources;

          //이미지 lri를 생성하고 리소스가 없을 시
          if (this.lriId && this.resources.length === 0) {
            this.resources = [];
            this.defaultResource.dateRange.startDate = this.defaultStartAt;
            this.defaultResource.dateRange.endDate = this.defaultEndAt;
            this.defaultResource.start_at = this.defaultStartAt;
            this.defaultResource.end_at = this.defaultEndAt;
            this.resources.push(
              JSON.parse(JSON.stringify(this.defaultResource)),
            );
          }
        } else {
          let lriData = {};
          this.inventory.options.forEach(option => {
            /**
             * 기존 옵션 이름으로 체크하던 조건 변경
             * option.name === '이미지 광고'
             */
            if (option.key === 'image') {
              lriData.item_id = this.imageItemId;
            }
            /**
             * 기존 옵션 이름으로 체크하던 조건 변경
             * option.name === '동영상 광고'
             */
            if (option.key === 'video') {
              lriData.item_id = this.videoItemId;
            }
            this.addLri(lriData);
          });
        }

        //resources 갱신
        if (emitData) {
          this.lris.forEach(lri => {
            if (lri.id === emitData.lriId) {
              this.resources = lri.resources;
            }
          });
          //resource가 없을 땐 defaultResource 넣어줌
          if (this.resources.length === 0 || !this.resources[0].id) {
            this.response = [];
            this.defaultResource.dateRange.startDate = this.defaultStartAt;
            this.defaultResource.dateRange.endDate = this.defaultEndAt;
            this.defaultResource.start_at = this.defaultStartAt;
            this.defaultResource.end_at = this.defaultEndAt;
            this.resources.push(
              JSON.parse(JSON.stringify(this.defaultResource)),
            );
          }
          this.$emit('upadate:campaignInfo');
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
      }
    },

    async addLri(lriData) {
      bus.$emit('start:spinner');
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.lineItemId;

      try {
        const { data } = await addOptionItem(
          campaignId,
          inventoryId,
          lineItemId,
          lriData,
        );
        if (data.result === 'success') {
          this.lriId = data.value;
          await this.getDetailLineItem();
        }
        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'IsAlreadyReserved') {
          this.showSystemAlert = true;
          this.logResult = '선택된 지면은 현재 집행중인 <br>캠페인이 있습니다.';
          await this.getDetailLineItem();
        }
      }
    },
    async updateLri(lriData) {
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.lineItemId;
      const lriId = this.lri.id;
      try {
        const { data } = await updateOptionItem(
          campaignId,
          inventoryId,
          lineItemId,
          lriId,
          lriData,
        );
        this.$forceUpdate();
        await this.getDetailLineItem();
      } catch (error) {
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'IsAlreadyReserved') {
          this.showSystemAlert = true;
          this.logResult = '선택된 지면은 현재 집행중인 <br>캠페인이 있습니다.';
          await this.getDetailLineItem();
        }
      }
    },

    async saveLineItem() {
      bus.$emit('start:spinner');
      const campaignId = this.$route.params.id;
      const inventoryId = this.propsInventoryId;
      const lineItemId = this.lineItemId;

      const link_type =
        this.linkSelectChoice && this.linkSelectChoice === '외부(새창)'
          ? 'external'
          : 'internal';

      let updateData = {
        is_valid: this.isValid,
        start_at: toISOFormattedDate(new Date(this.propsDateRange.startDate)),
        end_at: toISOFormattedDate(new Date(this.propsDateRange.endDate)),
        link_type: link_type,
        link_url: this.linkUrl,
      };

      try {
        const { data } = await updateDetailCampaignLineItem(
          campaignId,
          inventoryId,
          lineItemId,
          updateData,
        );
        if (data.result === 'success') {
          this.showSystemAlert = true;
          this.logResult = '저장되었습니다.';
        }
        await this.getDetailLineItem();

        bus.$emit('end:spinner');
      } catch (error) {
        bus.$emit('end:spinner');
        console.log(error.response);
        const { data } = error.response;
        if (data.result === 'IsAlreadyReserved') {
          this.showSystemAlert = true;
          this.logResult =
            '선택하신 캠페인에 포함된 상품(지면)중 <br>현재 다른 캠페인에서 사용중인 지면이 <br>포함되어 있습니다.<br><br>지면별 일정을 확인 / 수정후<br>다시 시도해주시기 바랍니다.';
        }
      }
    },

    updateDetailLineitemForResource(data) {
      this.getDetailLineItem(data);
    },
    deleteDetailLineitemForResource(data) {
      this.getDetailLineItem(data);
    },
    typeChange(e) {
      this.lris.forEach(lri => {
        if (lri.client_key === e) {
          this.lriId = lri.id;
        }
      });
    },
    cancel() {
      this.$emit('close:detail', this.propsInventory);
    },
    onClickRedirect() {
      let result = '';
      const url = this.linkUrl.replace(/\s/g, '');
      const lowerUrl = `${url}`.toLowerCase();
      if (!lowerUrl.startsWith('http://') && !lowerUrl.startsWith('https://')) {
        result = `https://${url}`;
      } else {
        result = url;
      }
      window.open(result, '_blank');
    },
  },
  async created() {
    bus.$emit('start:spinner');
    await this.getOptions();
    await this.getDetailLineItem();
  },
};
</script>

<style scoped></style>
